module.exports = __webpack_public_path__ + "static/media/categories-logo-figma.0cf7326b.svg";